import React from 'react'
import aboutImg1 from '../assets/images/about-img-1.jpg';
import contactUsImg from '../assets/images/contact-us-img.svg';
import iconFinancialStrategies from '../assets/images/icon-financial-strategies.svg';
import iconPhone from '../assets/images/icon-phone.svg';
import author1 from '../assets/images/author-1.jpg';
import author2 from '../assets/images/author-2.jpg';
import author3 from '../assets/images/author-3.jpg';
import iconService1 from '../assets/images/icon-service-1.svg';
import iconService2 from '../assets/images/icon-service-2.svg';
import iconService3 from '../assets/images/icon-service-3.svg';
import iconService4 from '../assets/images/icon-service-4.svg';
import iconService5 from '../assets/images/icon-service-5.svg';
import iconService6 from '../assets/images/icon-service-6.svg';
import arrowWhite from '../assets/images/arrow-white.svg';
import whyChooseImg1 from '../assets/images/why-choose-img-1.jpg';
import whyChooseImg2 from '../assets/images/why-choose-img-2.jpg';
import iconWhyChoose1 from '../assets/images/icon-why-choose-2.svg';
import iconWhyChoose2 from '../assets/images/icon-why-choose-2.svg';
import aboutImg2 from '../assets/images/about-img-2.jpg';


import iconPricingBenefit1 from '../assets/images/icon-pricing-benefit-1.svg';
import iconPricingBenefit2 from '../assets/images/icon-pricing-benefit-2.svg';


import mission from '../assets/images/icon-our-mission.svg';
import ourvision from '../assets/images/icon-our-vision.svg';
import ourvisionnn from '../assets/images/our-vision-img.jpg';
import ourvalueimg from '../assets/images/our-value-img.jpg';
import iconourfeature1 from '../assets/images/icon-our-feature-1.svg';
import iconourfeature2 from '../assets/images/icon-our-feature-2.svg';
import iconourfeature3 from '../assets/images/icon-our-feature-3.svg';
import iconourfeature4 from '../assets/images/icon-our-feature-4.svg';
import iconourfeature5 from '../assets/images/icon-our-feature-5.svg';
import iconourfeature6 from '../assets/images/icon-our-feature-6.svg';
import ourbenefit from '../assets/images/our-benefit-img.jpg';
import ourbenefit1 from '../assets/images/icon-our-benefit-1.svg';
import ourbenefit2 from '../assets/images/icon-our-benefit-2.svg';
import ourbenefit3 from '../assets/images/icon-our-benefit-3.svg';
import ourbenefit4 from '../assets/images/icon-our-benefit-4.svg';
import ourpartner1 from '../assets/images/our-partner-1.svg';
import ourpartner2 from '../assets/images/our-partner-2.svg';
import ourpartner3 from '../assets/images/our-partner-3.svg';
import ourpartner4 from '../assets/images/our-partner-4.svg';

import imagesteam1 from '../assets/images/team-1.jpg';
import imagesteam2 from '../assets/images/team-2.jpg';
import imagesteam13 from '../assets/images/team-3.jpg';
import customerlogo from '../assets/images/customer-logo.svg';
import testimonialquotes from '../assets/images/testimonial-quotes.svg';
import icongoogle from '../assets/images/icon-google.svg';
import customerratingimg from '../assets/images/customer-rating-img.svg';
import faqsimg from '../assets/images/faqs-img.jpg';
import faqsimsatisfyclientimg1 from '../assets/images/satisfy-client-img-1.jpg';
import faqsimsatisfyclientimg2 from '../assets/images/satisfy-client-img-2.jpg';
import faqsimsatisfyclientimg3 from '../assets/images/satisfy-client-img-3.jpg';
import faqsimsatisfyclientimg4 from '../assets/images/satisfy-client-img-4.jpg';
import faqsimsatisfyclientimg5 from '../assets/images/satisfy-client-img-5.jpg';
import iconourvalue from '../assets/images/icon-our-value.svg';
import whatwedoimg1 from '../assets/images/what-we-do-img-2.jpg';
import whatwedoimg2 from '../assets/images/what-we-do-img-2.jpg';
import whatwedoimg from '../assets/images/what-we-do-img-1.jpg';
import ourmissionimg from '../assets/images/our-mission-img.jpg';
import ourbenefit01 from '../assets/images/our-benefit-img.jpg';

// import conourvalue from '../assets/images/icon-our-value.svg"';



function Acceptdomesticpayment() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Accept Domestic Payment
                </h1>
               
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>


      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">

              <div className="our-benefit-content">

                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">our benefits</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Accept Domestic <span>Payments</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Embrace the convenience of payments with Click4pay Services. Our API integration enables fast and secure transactions, providing a hassle-free experience for both businesses and customers. Our solutions are designed to enhance efficiency and reliability.
                  </p>
                </div>

                <div className="our-benefit-btn wow fadeInUp" data-wow-delay="0.4s">
                  <a href="contact.html" className="btn-default">
                    get started
                  </a>
                </div>

                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>

            </div>
            <div className="col-lg-6">

              <div className="our-benefit-box">

                <div className="our-benefit-list">

                  <div className="our-benefit-item wow fadeInUp">
                    <div className="icon-box">
                      <img src={ourbenefit1} alt="ourbenefit1" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>UPI</h3>
                      <p>
                        Access to professionals with in-depth industry seasoned
                        knowledge.
                      </p>
                    </div>
                  </div>

                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit2} alt="ourbenefit2" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Credit & Debit Cards</h3>
                      <p>
                        Access to professionals with in-depth industry seasoned
                        knowledge.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit3} alt="ourbenefit3" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Netbanking</h3>
                      <p>
                        Access to professionals with in-depth industry seasoned
                        knowledge.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit4} alt="ourbenefit4" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Wallets</h3>
                      <p>
                        Access to professionals with in-depth industry seasoned
                        knowledge.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                </div>
                {/* Our Benefit List End */}
                {/* Our Benefit Get Quote Text Start */}
                <div
                  className="our-benefit-get-quote wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <p>
                    {" "}
                    Let's make something great work together.{" "}
                    <a href="contact.html">Get Free Quote</a>
                  </p>
                </div>
                {/* Our Benefit Get Quote Text End */}
              </div>
              {/* Our Benefit Box End */}
            </div>
          </div>
        </div>
      </div>


      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Your data security is <span>our priority</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    We understand the importance of your financial & data security. That’s why we have implemented the most robust security measures to safeguard your transactions with the best features compliant with data privacy and security.
                  </p>
                </div>
                <div className="what-we-do-list wow fadeInUp" data-wow-delay="0.4s">
                  <ul>
                    <li>strategic financial planning</li>
                    <li>expert investment advisory</li>
                    <li>risk assessment &amp; mitigation</li>
                    <li>retirement &amp; future planning</li>
                  </ul>
                </div>
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                <div className="what-we-do-btn wow fadeInUp" data-wow-delay="0.6s">
                  <a href="contact.html" className="btn-default">
                    contact now
                  </a>
                </div>
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>

      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="our-benefit-content">
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>

            </div>
            <div className="col-lg-6">

              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Experience the lightning fast <span>transactions with us</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Experience lightning-fast transactions with us. We ensure your transactions are processed through our platform in seconds.
                  </p>
                </div>


              </div>



            </div>
          </div>
        </div>
      </div>

     



      
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Dashboard is designed for your <span>convenience</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
A clean and visually appealing interface is crafted to present information clearly and organized, allowing you to grasp key insights at a glance effortlessly. We prioritize simplicity without compromising functionality, ensuring that even complex tasks can be easily accomplished.                  </p>
                </div>
                
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>




    </>
  )
}

export default Acceptdomesticpayment